import React, { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Snackbar, TextField } from '@material-ui/core';
import DatapPrameter from '../../data.js';
import classNames from 'classnames';
import MuiAlert from '@material-ui/lab/Alert';
import Typography from '@material-ui/core/Typography';
import Autocomplete from '@material-ui/lab/Autocomplete';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import LensIcon from '@material-ui/icons/Lens';
import { TransactionTime } from '../common/transactionTime';
import { HttpService } from '../../apiAuthorization/httpService';

const useStyles = makeStyles(theme => ({
    textColor: {
        color: '#4183c4!important',
        '& > label': {
            color: '#4183c4!important'
        },
        '& > div > label': {
            color: '#4183c4!important'
        }
    },
    listItemIcon: {
        minWidth: '20px'
    },
    lensIcon: {
        width: '10px'
    },
    mb5: {
        marginBottom: "5px"
    },
    mb10: {
        marginBottom: "10px"
    },
    textCenter: {
      textAlign:'Center'
    }
}));

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const AttendantCheckList = forwardRef((props, ref) => {
    const classes = useStyles();
    const { patientSittingSelected, startObservation, onDisableWithStyle, attendants, isManuallyShowAttendantCheckList, selectPatientObservationAttendantDto, close, safetyChecklistDto } = props;
    const [attendantChecklist, setAttendantChecklist] = useState({
        SituationalAwareness: {
            Title: "",
            Items:[]
        },
        ObserverAcknowledgement: {
            Title: "",
            Items: []
        }
    });
    const [attendantSelected, setAttendantSelected] = useState({ FirstName: "", LastName: "" });
    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [patientObservationAttendantDto, setPatientObservationAttendantDto] = useState(selectPatientObservationAttendantDto);
    const closeErrorSnackbar = () => {
        setOpenError(false);
    };
    const openErrorSnackbar = () => {
        setOpenError(true);
    };
    const [canSave, setCanSave] = useState(true);

    const onAttendantSelected = (event, values, id) => {
        if (values?.AppUserName) {
            var name = (values.FirstName == null ? '' : values.FirstName) + " " + (values.LastName == null ? '' : values.LastName);
            setPatientObservationAttendantDto({ ...patientObservationAttendantDto, Attendant: name, AttendantUsername: values.AppUserName });
            setAttendantSelected(values);
        }
    };

    const disabledAcceptPOSAChecklist = function () {

        if (!patientObservationAttendantDto) return true;
        if (!patientObservationAttendantDto.Attendant) return true;
        if (!patientObservationAttendantDto.ChargeNurseName) return true;
        return false;
    };

    const acceptPOSAChecklist = function () {

        if (disabledAcceptPOSAChecklist() || !canSave) return;
        setCanSave(false);
        var dto = patientObservationAttendantDto;
        if (safetyChecklistDto && safetyChecklistDto.AppPatientSittingId) {
            dto.AppPatientSittingId = safetyChecklistDto.AppPatientSittingId;
            dto.ObserverSignature = safetyChecklistDto.ObserverSignature;
            dto.RNSignature = safetyChecklistDto.RNSignature;
            dto.SignatureDateTime = safetyChecklistDto.SignatureDateTime;
        }
        else {
            dto.AppPatientSittingId = patientSittingSelected.Id;
        }

        if (!isManuallyShowAttendantCheckList) {
            TransactionTime.end();
            TransactionTime.updateData(dto);
        }

        HttpService.post("/PatientSitting/SavePOSAChecklist",
            dto
        ).then((result) => {
            if (result.error) {
                setCanSave(true);
                setErrorMessage(result.data);
                openErrorSnackbar();
                return;
            }
            close();
            if (isManuallyShowAttendantCheckList) return;
            TransactionTime.cancel();
            startObservation(patientSittingSelected);
        },
            (error) => {
                //This is intentional
            });
    };

    const declinePOSAChecklist = function () {
        if (!isManuallyShowAttendantCheckList) TransactionTime.cancel();
    };

    useImperativeHandle(ref, () => {
        return {
            save: acceptPOSAChecklist,
            cancel: declinePOSAChecklist
        };
    });

    useEffect(() => {

        var objCopy = JSON.parse(JSON.stringify(DatapPrameter.attendantChecklist));
        setAttendantChecklist(objCopy);
        onDisableWithStyle(true);
        if (!isManuallyShowAttendantCheckList) {
            TransactionTime.begin('startAttendantCheckList');
        }
        if (selectPatientObservationAttendantDto.Attendant) {
            var name = selectPatientObservationAttendantDto.Attendant.split(' ');
            setAttendantSelected({ FirstName: name[0], LastName: name[1] });
        }
        // eslint-disable-next-line 
    }, []);


    useEffect(() => {
        onDisableWithStyle(disabledAcceptPOSAChecklist());
        // eslint-disable-next-line 
    }, [patientObservationAttendantDto]);

    return (
        <div className={classes.textColor}>
            <Snackbar open={openError} autoHideDuration={3000} onClose={closeErrorSnackbar} style={{ height: "100%" }}>
                <Alert onClose={closeErrorSnackbar} severity="error">
                    {errorMessage}
                </Alert>
            </Snackbar>
            <Typography variant="body1" gutterBottom>
                Providing continued patient observation and safety is our utmost priority.  It is important that we provide the patient and their loved ones with the best service possible.  All Patient Observation Attendants are responsible for the below to ensure we are keeping the patient safe so that the clinical staff can work to heal.
            </Typography>
            <Typography variant="body1" gutterBottom>
                To ensure understanding, each Patient Observation Attendant must agree to the below competencies prior to starting any Crothall Healthcare and/or Compass One Patient Observation Attendant Position.
            </Typography>
            <br />
            <br />
            <Typography ariant="title">
                <strong>As a Patient Observation Attendant...</strong>
            </Typography>
            <div>
                <Typography ariant="title" className={classes.textCenter}>
                    <strong>{attendantChecklist.SituationalAwareness.Title}</strong>
                </Typography>
                <List id="SituationalAwareness">
                    {
                        attendantChecklist.SituationalAwareness.Items.map((item) => {
                            return (
                                <ListItem key={`SituationalAwareness-${item.Id}`}>
                                    <ListItemIcon className={classes.listItemIcon} >
                                        <LensIcon className={classNames(classes.lensIcon, classes.textColor)} />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={item.Text}
                                    />
                                </ListItem>
                            )
                        })
                    }
                </List>
                <Typography ariant="title" className={classes.textCenter}>
                    <strong>{attendantChecklist.ObserverAcknowledgement.Title}</strong>
                </Typography>
                <List id="ObserverAcknowledgement">
                    {
                        attendantChecklist.ObserverAcknowledgement.Items.map((item) => {
                            return (
                                <ListItem key={`ObserverAcknowledgement-${item.Id}`}>
                                    <ListItemIcon className={classes.listItemIcon} >
                                        <LensIcon className={classNames(classes.lensIcon, classes.textColor)} />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={item.Text}
                                    />
                                </ListItem>
                            )
                        })
                    }
                </List>
            </div>
            <br />
            <TextField size="small" fullWidth
                className={classNames(classes.mb10, classes.textColor)}
                label="Additional Information"
                variant="outlined"
                multiline
                rows="4"
                value={patientObservationAttendantDto.Comments || ""}
                onChange={(e) => { setPatientObservationAttendantDto({ ...patientObservationAttendantDto, Comments: e.target.value.trimStart() }); }}
                InputLabelProps={{
                    shrink: true,
                }}
            />
            <Autocomplete
                size="small"
                id="Attendant"
                options={attendants || []}
                className={classNames(classes.mb10, classes.textColor)}
                getOptionLabel=
                {
                    (option) => `${option?.FirstName == null ? '' : option.FirstName} ${option?.LastName == null ? '' : option.LastName}`
                }
                value={attendantSelected}
                filterSelectedOptions
                getOptionSelected={(option, value) => option.FirstName === value.FirstName}
                onChange={(e, v) => onAttendantSelected(e, v, 13)}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        label="Patient Observation Attendant’s Name"
                        placeholder="Attendant"
                    />
                )}
            />
            <TextField size="small" fullWidth
                label="Charge Nurse/RN’s Name"
                variant="outlined"
                className={classNames(classes.mb10, classes.textColor)}
                value={patientObservationAttendantDto.ChargeNurseName || ""}
                onChange={(e) => { setPatientObservationAttendantDto({ ...patientObservationAttendantDto, ChargeNurseName: e.target.value.trimStart() }); }}
                InputLabelProps={{
                    shrink: true,
                }}
            />
            <Typography variant="body1" gutterBottom>
                Selecting the Accept All button confirms your understanding of the listed responsibilities and that you agree to abide by them.
            </Typography>
        </div>
    );
});

export default AttendantCheckList;